import { render, staticRenderFns } from "./UneditableWhenEmptyConfig.vue?vue&type=template&id=959cf51e&"
import script from "./UneditableWhenEmptyConfig.vue?vue&type=script&lang=js&"
export * from "./UneditableWhenEmptyConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports